import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { Order } from "../../utils/constants/types";
import getRecommendedArticlesForOrder from "../../utils/recommendations";
import { CardItem, CardItemContainer } from "./CardItem";
import { ArticleID } from "../../utils/constants/recommendationMaps";

const NEED_HELP_GETTING_STARTED_TITLE = msg({
  id: "Recommendations_need_help_getting_started",
  message: "Need help getting started?",
});

const RECOMMENDED_ARTICLE_TITLES: Record<ArticleID, ReturnType<typeof msg>> = {
  [ArticleID.QuickStart]: msg({
    id: "Recommendations_quickstart_guides",
    message: "Quickstart Guides",
  }),
  [ArticleID.Warranty]: msg({
    id: "Recommendations_warranty_information",
    message: "Warranty Information",
  }),
};

interface Props {
  order: Order;
}

export default function RecommendedArticles({ order }: Props) {
  const { _: i18n } = useLingui();

  const recommendedArticles = getRecommendedArticlesForOrder(order);
  if (!recommendedArticles) return <></>;

  return (
    <CardItemContainer title={i18n(NEED_HELP_GETTING_STARTED_TITLE)}>
      {recommendedArticles.slice(0, 2).map((article, index) => {
        const localizedTitle = RECOMMENDED_ARTICLE_TITLES[article.id]
          ? i18n(RECOMMENDED_ARTICLE_TITLES[article.id])
          : article.title;

        return (
          <CardItem
            key={index}
            imgSrc={article.img}
            href={article.url}
            title={localizedTitle}
            labels={article.labels}
          />
        );
      })}
    </CardItemContainer>
  );
}
